export const getParsedJSON = (
  str: string,
): { isValidJSON: boolean; parsedJSON: string } => {
  let isValidJSON = false;
  let parsedJSON = "";
  try {
    parsedJSON = JSON.parse(str);
    isValidJSON = true;
  } catch {
    isValidJSON = false;
  }

  return { isValidJSON, parsedJSON };
};

export const parseImage = (image: string): string => {
  const { parsedJSON, isValidJSON } = getParsedJSON(image);

  if (!isValidJSON) {
    return "";
  }

  if (parsedJSON.length > 0) {
    return parsedJSON[0];
  }

  return "";
};
